export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.config.errorHandler = (error, instance, info) => {
    console.log('error-handler', error)
  }

  nuxtApp.hook('vue:error', (err) => {
    console.log('hook error-handler', err)
  })
})